import {EntityMatchModel} from "../../../../../core/components/router/models/entity.match-model";
import {CompetitorMatchesPageLinkParams} from "./competitor.matches-page.link-params";

export class CompetitorMatchesPageMatchModel extends EntityMatchModel {
  params: CompetitorMatchesPageLinkParams;

  constructor(params: Object, path: String, url: String, hash: String) {
    super(params, path, url, hash);

    const urlParams =  url.split('/')
    const page = urlParams?.length > 4 ? urlParams.last() : null;

    this.params = new CompetitorMatchesPageLinkParams(this.entityId(params), params.sportName, this.entityName(params), page);
  }
}